import { toJS } from "mobx";

export type WithModified<T> = T & { __modified: string[] };

export function deepClone<T>(value: T): T {
  return toJS(value);
}

export function updateItemWithModified<T extends Record<string, any>>(
  item: WithModified<T>,
  name: string,
  value: unknown,
): WithModified<T> {
  const currentValue = item[name];
  const isChanged = String(currentValue) !== String(value);

  const modifiedFields = new Set(item.__modified);

  if (isChanged) {
    modifiedFields.add(name);
  } else {
    modifiedFields.delete(name);
  }

  return {
    ...item,
    [name]: value,
    __modified: Array.from(modifiedFields),
  };
}

export function resetModified<T extends Record<string, any>>(
  item: WithModified<T>,
): WithModified<T> {
  return { ...item, __modified: [] };
}

export function filterModified<T extends Record<string, any>>(
  items: WithModified<T>[],
): WithModified<T>[] {
  return items.filter((item) => item.__modified?.length > 0);
}
